<template>
  <div class="container-fluid page-padding margin_55_55 mt-5">
    <div class="row pt-4">
      <div class="col-lg-8 col-12">
        <div class="main_title_2">
        <!-- <span><em></em></span> -->
        <h2>Support Request</h2>
        <!-- <p>Cum doctus civibus efficiantur in imperdiet deterruisset.</p> -->
      </div>
        <div class="bg-white">
          <div class="box_general padding_bottom">
            <div>
              <Form class=""  @submit="createTicket" ref="form"
              :validation-schema="supportRequestFormValidationSchema">
                <!-- <h4>Support Request</h4> -->
                <div class="form-group">
                  <label>Type of Support</label>
                  <Field as="select"
                    name="Type"
                    class="form-control"
                    v-model="supportRequestModel.Type"
                  >
                    <option value="0" selected>Select Type</option>
                    <option value="1">Ask a question</option>
                    <option value="2">Request a feature</option>
                    <option value="3">Report a bug</option>
                  </Field>
                  <ErrorMessage class="text-danger" name="Type" />
                </div>
                <div class="form-group" v-if="storeList">
                  <label>Shop</label>
                  <select
                    class="form-control"
                    v-model="supportRequestModel.ShopId"
                  >
                    <option value="0" selected>Select Shop</option>
                    <option
                      v-for="(store, index) in storeList"
                      :value="store.Id"
                      :key="index"
                    >
                      {{ store.Name }}
                    </option>
                  </select>
                </div>

                <div class="form-group">
                  <label>Subject <span class="text-danger">*</span></label>
                  <Field 
                    type="text"
                    name="Subject"
                    class="form-control"
                    v-model="supportRequestModel.Subject"
                  />
                  <ErrorMessage class="text-danger" name="Subject" />
                </div>
                <!-- /row-->
                <div class="form-group" v-if="categorylistData">
                  <label>Category</label>
                  <Field as="select"
                    name="Category"
                    class="form-control"
                    v-model="supportRequestModel.CategoryId"
                  >
                    <option value="0" disabled selected>Select Category</option>
                    <option
                      v-for="category in categorylistData"
                      :value="category.Id"
                      :key="category.Id"
                    >
                      {{ category.Title }}
                    </option>
                  </Field>
                  <ErrorMessage class="text-danger" name="Category" />
                </div>
                <div class="form-group">
                  <label>Description</label>
                   <TinyMce class="w-100"  v-model="supportRequestModel.Description"></TinyMce>
                  <Field as="textarea" maxlength="2000"
                    class="d-none mb-0 form-control"
                    name="Description"
                    v-model="supportRequestModel.Description"
                    placeholder=""
                  ></Field>
                  <ErrorMessage class="text-danger" name="Description" />
                </div>
                <p class="add_top_30">
                  <button
                    type="submit"
                    class="btn_1 rounded"
                    id="submit-contact"
                  >
                    Create Ticket
                  </button>
                </p>
              </Form>
            </div>
          </div>
        </div>
      </div>
      <aside class="col-lg-4 bg-white h-100  col-12 pt-3">
        <div class="widget-title">
            <h3>Other Tickets</h3>
          </div>
        <form class="mb-4">
          <div class="widget-title border-0 mb-0">
            <h4>Filter by Shop</h4>
          </div>
          <div class="form-group" v-if="storeList">
             <select v-model="shopId"  @change="loadFeedbackList"
                class="form-control"
              >
                <option value="0" selected>Select Shop</option>
                <option
                  v-for="(store, index) in storeList"
                  :value="store.Id" 
                  :key="index"
                >
                  {{ store.Name }}
                </option>
              </select>
              <small class="text-danger" v-if="errors.ShopId">{{
                errors.ShopId
              }}</small>
            </div>
        </form>
        <!-- /widget -->
        <div class="widget">
          
          <ul class="comments-list" v-if="feedbacklistData.length> 0">
            <li
              v-for="(feedback, index) in feedbacklistData"
              :value="feedback"
              :key="index"
            >
              <small>
                {{
                  new Date(feedback.CreatedAt).toLocaleString().replace(",", "")
                }}
              </small>
              <h3>
                <router-link
                  :to="{
                    path: '/feedback-details/' + feedback.Id,
                  }"
                  >{{ feedback.Subject }}</router-link
                >
              </h3>
            </li>
          </ul>
          <p v-else>No ticket found</p>
        </div>
        <!-- /widget -->
      </aside>
    </div>
  </div>
</template>

<script>
import TinyMce from '../components/Utility/tinymce-editor.vue'
import CategoryService from '../services/category-service'
import SupportService from '../services/support-service'
import StoreService from '../services/store-service'
import SupportRequest from '../models/SupportRequest'
import _ from 'lodash'
import { Field, Form, ErrorMessage } from 'vee-validate'
import ValidationService from '../services/validation.service'
export default {
  name: 'SupportTicket',
  data() {
    return {
      feedbacklistData: [],
      shopId: 0,
      storeList: [],
      supportRequestModel: new SupportRequest(),
      errors: {},
      categorylistData: [],
      selectedCategory: { Id: 0 },
      supportRequestFormValidationSchema: ValidationService.ticket,
    }
  },
  components: { TinyMce, Form, ErrorMessage, Field },
  mounted() {
    this.fetchAllCategories()
    this.fetchStoresOfUser()
  },
  methods: {
    loadFeedbackList() {
      this.feedbacklistData = []
      SupportService.getCurentUserFeedbackList(this.shopId).then(
        (response) => {
          if (response.data.Object) {
            this.feedbacklistData = _.orderBy(response.data.Object.feedbackList, ['UpdatedAt'],['desc'])
          } else {
            this.feedbacklistData = []
          }
        },
        (error) => {
          console.log(error)
        }
      )
    },
    fetchAllCategories() {
      CategoryService.getcategoryList().then(
        (response) => {
          this.categorylistData = response.data.Object.categories
        },
        (error) => {
          console.log(error)
        }
      )
    },
    fetchStoresOfUser() {
      StoreService.getCurrentUserStores().then(
        (response) => {
          if(response.data.Object){
            this.storeList = response.data.Object.storeList
          } else {
            this.storeList = []
          }
          if(this.storeList.length > 0) {
            this.shopId = this.storeList[0].Id
          }
          this.loadFeedbackList()
        },
        (error) => {
          console.log(error)
        }
      )
    },
    createTicket() {
      // this.CategoryId = this.selectedCategory.Id
      // this.isValidateFields()
      console.log(this.supportRequestModel)
      SupportService.createNewTicket(this.supportRequestModel).then(
        (response) => {
          console.log(response)
          if (response.data.Status) {
            alert(response.data.Message)
            this.loadFeedbackList()
            this.resetForm()
          }
        },
        (error) => {
          console.log(error)
        }
      )
    },
    resetForm() {
      this.$refs.form.resetForm()
      this.supportRequestModel = new SupportRequest()
      this.selectedCategory.Id = 0
    },
  },
}
</script>